import { render, staticRenderFns } from "./500.vue?vue&type=template&id=28b33cfe&scoped=true&"
import script from "./500.vue?vue&type=script&lang=js&"
export * from "./500.vue?vue&type=script&lang=js&"
import style0 from "./500.vue?vue&type=style&index=0&id=28b33cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b33cfe",
  null
  
)

export default component.exports